"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiTokens = exports.useApiTokensWithReady = exports.getAnonToken = exports.clearAnonToken = exports.setAnonToken = void 0;
var react_1 = require("react");
var auth0_react_1 = require("@auth0/auth0-react");
var cookies_1 = require("./cookies");
var anonTokenKey = 'anonymous_user_token';
var setAnonToken = function (token) {
    return (0, cookies_1.setCookie)({
        name: anonTokenKey,
        value: token,
        secure: !!window.location.host.match('gethank.com'),
    });
};
exports.setAnonToken = setAnonToken;
var clearAnonToken = function () {
    return (0, cookies_1.clearCookie)({
        name: anonTokenKey,
    });
};
exports.clearAnonToken = clearAnonToken;
var getAnonToken = function () { return (0, cookies_1.getCookie)(anonTokenKey); };
exports.getAnonToken = getAnonToken;
var useApiTokensWithReady = function (apiBase) {
    var _a = (0, auth0_react_1.useAuth0)(), isLoading = _a.isLoading, user = _a.user, getAccessTokenSilently = _a.getAccessTokenSilently;
    var _b = (0, react_1.useState)(), auth0Token = _b[0], setAuth0Token = _b[1];
    (0, react_1.useEffect)(function () {
        if (isLoading || auth0Token)
            return;
        if (!user) {
            setAuth0Token(null);
            return;
        }
        var getToken = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAccessTokenSilently({
                                audience: apiBase,
                            })];
                    case 1:
                        accessToken = _a.sent();
                        setAuth0Token(accessToken);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1.message, e_1);
                        setAuth0Token(null);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getToken();
    }, [isLoading, user, getAccessTokenSilently, auth0Token, setAuth0Token]);
    // Clear anon cookie once we have an authenticated token
    (0, react_1.useEffect)(function () {
        if (!(auth0Token && (0, exports.getAnonToken)()))
            return;
        (0, exports.clearAnonToken)();
    }, [auth0Token]);
    return {
        auth0Token: auth0Token,
        anonymousToken: (0, exports.getAnonToken)(),
        // auth0Token is priority, so can return early if we have one, otherwise wait until we've checked for both tokens
        ready: auth0Token || auth0Token === null,
    };
};
exports.useApiTokensWithReady = useApiTokensWithReady;
var useApiTokens = function (apiBase) {
    var _a = (0, exports.useApiTokensWithReady)(apiBase), ready = _a.ready, tokens = __rest(_a, ["ready"]);
    if (!ready)
        return {};
    return tokens;
};
exports.useApiTokens = useApiTokens;
//# sourceMappingURL=api-token.js.map